import React, { useEffect, useState } from 'react';

import moment from 'moment';
import { useDispatch } from 'react-redux';

// import {S3Client} from '@aws-sdk/client-s3';
// import {Upload as S3Upload} from '@aws-sdk/lib-storage';

import Style from './Resume.module.css';

import { createResume } from '../../../../redux/actions/aeMyProfile';
import { uploadToS3 } from '../../../../redux/actions/fileUpload';
import { SHOW_TOAST } from '../../../../redux/types';

import { Button } from '../../../atoms';

import { isEmpty } from '../../../../utils/generic';

function Resume({ resumeLink, setResumeLink, setSection, showThirdBtn, fillViaResume, setFillViaResume, resume, setCurrentJob, fetchResume }) {
  const [isSubmitting, setIsSubmitting] = useState(false); // when uploading resume
  const [isSubmitting2, setIsSubmitting2] = useState(false); // when parsing resume
  const [uploadedDate, setUploadedDate] = useState(resume?.created_at ? resume?.created_at : 'NA');
  const [fileName, setFileName] = useState(resume?.file_name ? resume?.file_name : '');
  const parsedData = resume?.parsed_data ? resume?.parsed_data : {};
  const [error, setError] = useState('');
  const dispatch = useDispatch();

  useEffect(() => {
    if (parsedData?.experience) {
      const currentJobEntry = parsedData.experience.find((ele) => ele?.end_date?.toLowerCase()?.includes('present'));

      if (currentJobEntry) {
        setCurrentJob({
          current_employer: currentJobEntry.company_name,
          current_role: currentJobEntry.designation
        });
      }
    }
  }, [parsedData]);

  useEffect(() => {
    setFileName(resume?.file_name ? resume?.file_name : '');
    setUploadedDate(resume?.created_at ? resume?.created_at : 'NA');
  }, [resume]);

  const validateFile = (file) => {
    const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
    const maxSize = 5 * 1024 * 1024; // 5MB

    if (!allowedTypes.includes(file.type)) {
      return 'Only PDF, doc, docx files are allowed.';
    }

    if (file.size > maxSize) {
      return 'File size exceeds the limit (5MB).';
    }

    return '';
  };

  const handleFileChange = async (event) => {
    event.preventDefault();

    if (event.target.files[0]) {
      setError('');
      setIsSubmitting(true);
      const file = event.target.files[0];

      const error = validateFile(file);

      if (error) {
        setError('Upload failed.');
        setIsSubmitting(false);
      } else {
        try {
          const response = await uploadToS3(file);

          setFileName(file.name);
          setUploadedDate(moment(new Date()).format('YYYY-MM-DD hh:mm:ss'));
          setResumeLink(response.url);
          setIsSubmitting(false);
          dispatch({
            type: `${SHOW_TOAST}`,
            payload: { type: 'success', message: 'Resume uploaded successfully.' }
          });
        } catch (e) {
          setError('Upload Failed');
          setIsSubmitting(false);
        }
      }
    }
  };

  const handleSubmit = () => {
    if (!isSubmitting2 && !isSubmitting) {
      // setResume({
      //   resume_link: resumeLink,
      //   file_name: fileName,
      //   updated_at: uploadedDate
      // });

      setSection({ value: 'Work Details', id: 1 });
    }
  };

  const handleBack = () => {
    if (!isSubmitting2 && !isSubmitting) {
      setSection({ value: 'Work Details', id: 1 });
    }
  };

  // const handleManualSubmit = () => {
  //   if (!isSubmitting2 && !isSubmitting) {
  //     setFillViaResume(false);
  //     setResume({
  //       resume_link: resumeLink,
  //       file_name: fileName,
  //       updated_at: uploadedDate
  //     });
  //     setSection({ value: 'Work Details', id: 1 });
  //   }
  // };

  const handleParsing = () => {
    if (!isEmpty(resume) && resumeLink === resume?.resume_link && !isEmpty(resume?.parsed_data)) {
      setFillViaResume(true);
    } else {
      setIsSubmitting2(true);
      const body = {
        resume: {
          resume_link: resumeLink,
          async: false
        }
      };

      dispatch(createResume(body))
        .then(() => {
          fetchResume();
          setFillViaResume(true);
          setIsSubmitting2(false);
        })
        .catch(() => {
          setIsSubmitting2(false);
        });
    }
  };

  const text1 = fillViaResume
    ? 'Filling via Resume is Complete. Click Next to see the filled details'
    : `Save time by letting AI fetch and fill your details from your resume by Clicking on 'Fill via Resume'`;

  const text2 = `Save time by letting AI fetch and fill your details from your resume by Clicking on 'Fill via Resume'`;

  const handleViewResume = () => {
    window.open(resumeLink);
  };

  return (
    <>
      <div className={`${Style.ResumeContainer}`}>
        <div className={Style.CentralInputSec}>
          <div className={Style.CentralPos}>
            <div className={`${Style.UpperResumeDiv} row`}>
              <div className='col-12'>
                <div className={`${Style.ResumeLink}`} data-testid='resume-filename'>
                  {isEmpty(fileName) ? 'NA' : fileName}
                </div>
              </div>
              {error === '' ? (
                <div className='col-12'>
                  <div className={Style.fontSmallBlue} onClick={handleViewResume}>
                    View Resume
                  </div>
                  <div className={`${Style.fontSmallGrey} ${Style.fontSmallBlue}`}>Uploaded on: {uploadedDate !== 'NA' ? moment(uploadedDate).format('DD-MM-YYYY') : 'NA'}</div>
                </div>
              ) : (
                <div className={`${Style.fontSmallRed} ${Style.fontSmallBlue}`}>{error}</div>
              )}
              {!showThirdBtn ? (
                <>
                  {!fillViaResume ? (
                    <div className='relative-position col-12 flex-style-center'>
                      <Button
                        className={isSubmitting ? 'general-outline-style gray-5' : isSubmitting2 ? 'general-outline-style gray-5' : 'general-outline-style blue'}
                        data-testid='upload-resume-button'
                        disabled={isSubmitting || fileName?.length == 0 || isSubmitting2}
                        isSubmitting={isSubmitting}
                      >
                        Upload New Resume
                      </Button>
                      <input
                        accept='.pdf,.doc,.docx'
                        className={Style.inputBoxUpload}
                        data-testid='upload-resume-input'
                        id='resume'
                        name='resume'
                        onChange={(e) => handleFileChange(e)}
                        type='file'
                      />
                    </div>
                  ) : null}
                </>
              ) : (
                <>
                  {!fillViaResume ? (
                    <div className='relative-position col-12 flex-style-center'>
                      <Button
                        className={isSubmitting ? 'general-outline-style gray-5' : isSubmitting2 ? 'general-outline-style gray-5' : 'general-outline-style blue'}
                        disabled={isSubmitting || fileName?.length == 0 || isSubmitting2}
                        isSubmitting={isSubmitting}
                      >
                        Upload New Resume
                      </Button>
                      <input accept='.pdf,.doc,.docx' className={Style.inputBoxUpload} id='resume' name='resume' onChange={(e) => handleFileChange(e)} type='file' />
                    </div>
                  ) : null}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className={`${Style.BottomAbsolute} full-width-imp`}>
        <div className={`${Style.ResumeContainer}  margin-0 row`}>
          {!showThirdBtn ? (
            <>
              {!fillViaResume ? (
                <>
                  <div className='col-12'>{text1}</div>
                  <div className='col-12 padding0L'>
                    <Button
                      className='general-style-3'
                      data-testid='fill-manually'
                      disabled={isSubmitting2 || fileName?.length == 0 || isSubmitting}
                      isSubmitting={isSubmitting2}
                      onClick={handleParsing}
                    >
                      Fill via Resume
                    </Button>
                  </div>
                  {/* <div
                    className={
                      isSubmitting
                        ? 'col-12 gray-5 font-16px height-20 padding16T fw-600 text-align-center'
                        : isSubmitting2
                          ? 'col-12 gray-5 font-16px height-20 padding16T fw-600 text-align-center'
                          : 'col-12 blue font-16px height-20 padding16T fw-600 text-align-center'
                    }
                    onClick={handleManualSubmit}
                  >
                    Let me fill it manually
                  </div> */}
                </>
              ) : (
                <>
                  <div className='col-12'>{text1}</div>
                  <div className='col-12 flex-style-space-between padding0L'>
                    <Button className='general-style-3' onClick={handleSubmit}>
                      Next
                    </Button>
                  </div>
                </>
              )}
            </>
          ) : (
            <>
              {!fillViaResume ? (
                <>
                  <div className='col-12'>{text2}</div>
                  <div className='col-12 padding0L blue m-t-20 center-x full-width-imp'>
                    <Button
                      className='general-outline-style full-width-imp  paddingTop'
                      disabled={isSubmitting || fileName?.length == 0 || isSubmitting2}
                      isSubmitting={isSubmitting2}
                      onClick={handleParsing}
                    >
                      {' '}
                      Fill via Resume
                    </Button>
                  </div>
                  {/* <div
                    className={
                      isSubmitting
                        ? 'col-12 gray-5 font-16px height-20 padding16T fw-600 text-align-center '
                        : isSubmitting2
                          ? 'col-12 gray-5 font-16px height-20 padding16T fw-600 text-align-center '
                          : 'col-12 blue font-16px height-20 padding16T fw-600 text-align-center '
                    }
                    disabled={isSubmitting || fileName?.length == 0 || isSubmitting2}
                    onClick={handleManualSubmit}
                  >
                    Let me fill it manually
                  </div> */}
                  <div className='col-12 flex-style-space-between padding0L'>
                    <Button className='general-style-3 margin-top-15' disabled={isSubmitting || fileName?.length == 0 || isSubmitting2} onClick={handleBack}>
                      Back to Work details
                    </Button>
                  </div>
                </>
              ) : (
                <>
                  <div className='col-12'>{text1}</div>
                  <div className='col-12 flex-style-space-between padding0L'>
                    <Button className='general-style-3' onClick={handleSubmit}>
                      Next
                    </Button>
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default Resume;
